document.addEventListener('DOMContentLoaded', () => {
  const BREAKPOINT = 750;

  const slider = document.querySelector('.product__pc-slider');
  const desktopWrap = document.querySelector('.single-desktop-load');
  const mobileWrap = document.querySelector('.single-mobile-load');

  if (!slider || !desktopWrap || !mobileWrap) return;

  function moveSlider() {
    if (window.innerWidth < BREAKPOINT) {
      // Move to mobile
      if (!mobileWrap.contains(slider)) {
        mobileWrap.appendChild(slider);
      }
    } else {
      // Move back to desktop
      if (!desktopWrap.contains(slider)) {
        desktopWrap.appendChild(slider);
      }
    }
  }

  // Initial check
  moveSlider();

  // On resize
  window.addEventListener('resize', moveSlider);
});

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.product__pc-slider');
  if (!slider) return;

  const pagiItems = slider.querySelectorAll('.product__pc-slider--thumb-item');
  const slideItems = slider.querySelectorAll('.product__pc-slider--thumbs--item');
  const dotItems   = slider.querySelectorAll('.product__pc-slider--dots--item');
  const prevBtn = slider.querySelector('.product__pc-slider--prev');
  const nextBtn = slider.querySelector('.product__pc-slider--next');

  const total = slideItems.length;
  if (total <= 1) return;

  function setActive(num) {
    pagiItems.forEach(item =>
      item.classList.toggle('active', item.dataset.num == num)
    );

    slideItems.forEach(item =>
      item.classList.toggle('active', item.dataset.num == num)
    );

    dotItems.forEach(item =>
      item.classList.toggle('active', item.dataset.num == num)
    );
  }

  function getCurrentNum() {
    const current = slider.querySelector('.product__pc-slider--thumbs--item.active');
    return current ? parseInt(current.dataset.num, 10) : 1;
  }

  /* Hover thumbs */
  pagiItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      setActive(item.dataset.num);
    });
  });

  /* Click dots */
  dotItems.forEach(item => {
    item.addEventListener('click', () => {
      setActive(item.dataset.num);
    });
  });

  /* Next */
  nextBtn?.addEventListener('click', () => {
    let current = getCurrentNum();
    let next = current + 1 > total ? 1 : current + 1;
    setActive(next);
  });

  /* Prev */
  prevBtn?.addEventListener('click', () => {
    let current = getCurrentNum();
    let prev = current - 1 < 1 ? total : current - 1;
    setActive(prev);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const scrollWrap = document.querySelector('.product__pc-slider--pagi');
  const scrollbar = document.querySelector('.product__pc-slider--scrollbar');
  const thumb = scrollbar?.querySelector('span');

  if (!scrollWrap || !scrollbar || !thumb) return;

  function updateScrollbar() {
    const scrollWidth = scrollWrap.scrollWidth;
    const clientWidth = scrollWrap.clientWidth;
    const scrollLeft = scrollWrap.scrollLeft;

    // Hide scrollbar if no overflow
    if (scrollWidth <= clientWidth) {
      scrollbar.style.display = 'none';
      return;
    } else {
      scrollbar.style.display = 'block';
    }

    // Thumb width (visible ratio)
    const thumbWidth = (clientWidth / scrollWidth) * scrollbar.clientWidth;
    thumb.style.width = `${thumbWidth}px`;

    // Thumb position
    const maxScrollLeft = scrollWidth - clientWidth;
    const maxThumbMove = scrollbar.clientWidth - thumbWidth;
    const translateX = (scrollLeft / maxScrollLeft) * maxThumbMove;

    thumb.style.transform = `translateX(${translateX}px)`;
  }

  // Initial
  updateScrollbar();

  // On scroll
  scrollWrap.addEventListener('scroll', updateScrollbar);

  // On resize
  window.addEventListener('resize', updateScrollbar);
});